// extracted by mini-css-extract-plugin
export default {"addjsblog":"d704efa400da997e125d"};